import styled from 'styled-components';

export const BannerBackgroundImgDiv = styled.div`
  max-width: ${p => p.theme.unit(142.5)};
  height: ${p => p.theme.unit(45)};
  position: relative;
  background-color: ${p => (p.hexForBackground ? p.hexForBackground : p.theme.c.bg.primary)};
`;

export const BannerBackgroundImg = styled.img`
  max-width: ${p => p.theme.unit(142.5)};
  height: ${p => p.theme.unit(45)};
  position: relative;
  background-color: ${p => p.theme.c.bg.primary};
`;

export const MobileBannerBackgroundImgDiv = styled(BannerBackgroundImgDiv)`
  max-width: 100%;
  height: ${p => p.theme.unit(40)};
`;

export const MobileBannerBackgroundImg = styled(BannerBackgroundImg)`
  max-width: 100%;
  height: ${p => p.theme.unit(40)};
`;
